module.exports = __webpack_public_path__ + "img/from-a.87efe70b.svg";